import { ReactElement } from 'react';

import {
  Button,
  ChakraFlex,
  ChakraImage,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';

import graphic from '~/assets/img/tasks-graphic.png';

const { h1, h5, h6 } = EquipUITheme.typography;

const TOP_LEVEL_ID = 'empty-task-list';

export interface ActionButton {
  key: string;
  buttonText: string;
  rightIcon?: ReactElement;
  onClick?: () => void;
}

export interface EmptyTaskListProps {
  actionButtons?: ActionButton[];
  description: string;
  primaryText: string;
  secondaryText: string;
  showGraphic?: boolean;
}

const EmptyTaskList = ({
  actionButtons = [],
  description,
  primaryText,
  secondaryText,
  showGraphic = false,
}: EmptyTaskListProps) => (
  <ChakraFlex
    alignItems="center"
    direction="column"
    height="100%"
    justifyContent="center"
    width="100%"
  >
    {showGraphic && <ChakraImage paddingBottom="40px" src={graphic} />}
    <ChakraText
      {...h1}
      color="neutral.primary"
      id={`${TOP_LEVEL_ID}__primary-text`}
      paddingBottom="8px"
    >
      {primaryText}
    </ChakraText>
    <ChakraText
      {...h5}
      color="neutral.primary"
      id={`${TOP_LEVEL_ID}__secondary-text`}
      paddingBottom="8px"
    >
      {secondaryText}
    </ChakraText>
    <ChakraText
      {...h6}
      color="neutral.secondary"
      id={`${TOP_LEVEL_ID}__description-text`}
      paddingBottom="16px"
    >
      {description}
    </ChakraText>
    <ChakraFlex>
      {actionButtons.map(
        ({ buttonText, rightIcon, onClick, key }: ActionButton) => (
          <Button
            fontSize="12px"
            fontWeight="700"
            id={`${TOP_LEVEL_ID}__${key}`}
            key={key}
            margin="10px"
            onClick={onClick}
            padding="8 24px"
            rightIcon={rightIcon}
            size="sm"
            variant="outline"
          >
            {buttonText}
          </Button>
        ),
      )}
    </ChakraFlex>
  </ChakraFlex>
);

export default EmptyTaskList;
